import { type TBannerEvents } from 'shared/types/events';

import { type IEventEmitter } from '../services/eventEmitter/IEventEmitter';

export type TSubscribeBannerLifecycleReportingParams = {
  eventEmitter: IEventEmitter;
  placeId: string;
  dispatchLifecycleEvent(event: TBannerEvents): void;
};

/**
 * Связывает внутренний EventEmitter баннера с внешним lifecycle-репортингом.
 *
 * Раньше это делал отдельный React-контекст (AdBannerEventsProvider + useAdBannerEvents):
 * он отдавал emitLoad/emitStub/emitError, которые подписывали на эмиттер. Теперь логика
 * объединена — события уходят прямо по подписке на эмиттер, без промежуточного контекста.
 */
export function subscribeBannerLifecycleReporting({
  eventEmitter,
  placeId,
  dispatchLifecycleEvent,
}: TSubscribeBannerLifecycleReportingParams): VoidFunction {
  const unsubscribes = [
    eventEmitter.subscribe('load', () =>
      dispatchLifecycleEvent({ name: `ad-banner-frontend-reporting.v1.${placeId}.ad-banner-load` }),
    ),

    eventEmitter.subscribe('stub', () =>
      dispatchLifecycleEvent({ name: `ad-banner-frontend-reporting.v1.${placeId}.ad-banner-stub` }),
    ),

    eventEmitter.subscribe('error', () =>
      dispatchLifecycleEvent({ name: `ad-banner-frontend-reporting.v1.${placeId}.ad-banner-error` }),
    ),

    eventEmitter.subscribe('close', () =>
      dispatchLifecycleEvent({ name: `ad-banner-frontend-reporting.v1.${placeId}.ad-banner-close` }),
    ),
  ];

  return (): void => {
    unsubscribes.forEach(unsubscribe => unsubscribe());
  };
}
